import { useState } from "react";
import { useFindId } from "../../hooks/auth/useFindId";
import { DebouncedInput } from "../../components/DebouncedInput";
import logo from "../../images/aivy_logo3.png";

const FindId = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const { isLoading, verificationResult, verifyPhoneNumber, verifyCode, foundId, error, resetVerification } = useFindId();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (verificationResult && !verificationResult.unmatched && !verificationResult.platform) {
      verifyCode(verificationCode);
    } else {
      await verifyPhoneNumber(phoneNumber);
    }
  };

  const formatPhoneNumber = (value: string) => {
    const numbers = value.replace(/[^\d]/g, "");
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 7)
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(
      7,
      11
    )}`;
  };

  const handlePhoneNumberChange = (value: string) => {
    const formatted = formatPhoneNumber(value);
    setPhoneNumber(formatted);
    
    if (verificationResult) {
      resetVerification();
      setVerificationCode(""); 
    }
  };

  const handleNavigation = (path: string): void => {
    window.location.href = path;
  };

  return (
    <div className="flex flex-col min-h-screen items-center justify-center font-serif-kr">
      <div className="flex items-center justify-center gap-2">
        <img src={logo} alt="Aivy Logo" className="w-20 h-20" />
        <button
          onClick={() => handleNavigation("/")}
          className="h-12 text-4xl font-bold bg-gradient-to-r from-teal-600/60 via-green-500 to-emerald-600/60 bg-clip-text text-transparent font-serif-en"
        >
          Aivy AI
        </button>
      </div>
      <div className="w-full max-w-md px-5 space-y-8">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">계정 찾기</h1>
          <p className="text-sm md:text-base text-gray-500">
            가입 시 등록한 휴대폰 번호를 입력해주세요.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <DebouncedInput
              type="tel"
              placeholder="휴대폰 번호 (예: 010-0000-0000)"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              maxLength={13}
              disabled={!!(verificationResult && !verificationResult.unmatched && !verificationResult.platform)}
              delay={300}
            />
          </div>

          {verificationResult &&
            !verificationResult.unmatched &&
            !verificationResult.platform && (
              <div className="space-y-2">
                <DebouncedInput
                  type="text"
                  placeholder="인증번호 6자리"
                  value={verificationCode}
                  onChange={setVerificationCode}
                  maxLength={6}
                  delay={300}
                />
              </div>
            )}

          {error && (
            <div className="rounded-lg bg-red-50 p-3 text-sm text-red-600 text-left">
              {error}
            </div>
          )}

          {foundId ? (
            <div className="space-y-4">
              <div className="rounded-lg bg-gray-200 p-4 text-center">
                <p className="text-lg md:text-xl font-semibold text-gray-800 mb-2">찾은 계정 정보</p>
                <p className="text-sm md:text-base font-semibold text-gray-800">아이디: {foundId}</p>
              </div>
              <button
                type="button"
                onClick={() => handleNavigation("/auth/signin")}
                className="w-full rounded-lg bg-gradient-to-r from-teal-600/70 via-green-500/90 to-emerald-600/50 px-4 py-2 text-white transition-all hover:shadow-lg transform hover:scale-105 duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                로그인하러 가기
              </button>
            </div>
          ) : (
            <button
              type="submit"
              disabled={isLoading || (verificationResult ? verificationCode.length !== 6 : phoneNumber.length < 13)}
              className="w-full rounded-lg bg-gradient-to-r from-teal-600/70 via-green-500/90 to-emerald-600/50 px-4 py-2 text-white text-sm md:text-base transition-all hover:shadow-lg transform hover:scale-105 duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading
                ? "처리중..."
                : verificationResult && !verificationResult.unmatched && !verificationResult.platform
                ? "인증번호 확인"
                : "계정 찾기"}
            </button>
          )}
        </form>

        {!foundId && (
          <div className="text-center text-sm md:text-base">
            <a
              href="/auth/signin"
              className="text-blue-500 hover:text-blue-600 transition-colors"
            >
              로그인으로 돌아가기
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default FindId;
